import { format, startOfWeek } from 'date-fns';
import { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

function CalendarNew({ date, setDate, actualDate, setActualDate }) {

  return (
    <>
      <p style={{ textAlign: 'center' }} className='hideMobile'>Choose the date you would like to see the sessions for.</p>
      <p style={{ textAlign: 'center' }} className='hideDesktop'>Choose the week you would like to see the sessions for.</p>
      <div className="calendar-new" style={{ margin: 'auto', marginBottom: '20px' }}>
        <Calendar onChange={v => { setActualDate(v); setDate(startOfWeek(v, { weekStartsOn: 1 })) }} value={actualDate} />
      </div>
    </>
  );
}

export default CalendarNew